<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadSummary="loadSummary"
      @loadUser="loadUser"
      :includeAdmin="true"
    ></results-bar>
    <results-summary :id="doc.id"></results-summary>
    <results-user
      v-if="!summary"
      :uid="currentUser"
      :id="doc.id"
    ></results-user>
  </div>
</template>

<script>
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary,
} from "@/components/results/service";
export default {
  name: "ResultSwot",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary,
  },
};
</script>
